<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-ticket</v-icon>{{$t('ticket.ticket')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <TicketForm ref="createForm" :values="item" :defaultvalues="defaultvalues" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import TicketForm from '../../components/ticket/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'Ticket';

const { mapFields } = createHelpers({
  getterType: 'ticket/getField',
  mutationType: 'ticket/updateField'
});

export default {
  name: 'TicketCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    TicketForm
  },
  data() {
    return {
      item: {

      },
      defaultvalues: {
        statusdefault: 'Nouveau',
        origindefault: 'Téléphone',
      }
    };
  },
  mounted() {
    this.item.customer = this.customerParent;
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations']),
    customerParent() {
      if (this.$route.params.parent) {
          return {'@id' :  this.$route.params.parent, 'name' :  this.$route.params.parent};
      }
      return null;
    },
  },
  methods: {
    ...mapActions('ticket', ['create', 'reset']),
  }
};
</script>
